import { useCallback, useEffect } from "react";
import styled from "styled-components";
const GetLatAndLonWrapper = styled.div`
  height: 0px;
`;
const GetLatAndLon = () => {
  const getLatAndLon = useCallback(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        console.log(position)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.postMessage(
          `/getLatAndLon?mLong=${
            position.coords.longitude || "116.39125"
          }&mLati=${position.coords.latitude || "39.90707"}`
        );
      },
      function (positionError) {
       // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.postMessage(
            `/getLatAndLon?mLong="116.39125"&mLati="39.90707"`
          );
      },{
        enableHighAccuracy:true
      }
    );
  }, []);

  useEffect(() => {
    getLatAndLon();
  }, [getLatAndLon]);

  return <GetLatAndLonWrapper></GetLatAndLonWrapper>;
};
export default GetLatAndLon;
